import { render, staticRenderFns } from "./MerchantMessagesPage.vue?vue&type=template&id=49b9f141"
import script from "./MerchantMessagesPage.vue?vue&type=script&lang=js"
export * from "./MerchantMessagesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports